import { render, staticRenderFns } from "./HomepageBits.vue?vue&type=template&id=6b31e48c&scoped=true&"
import script from "./HomepageBits.vue?vue&type=script&lang=js&"
export * from "./HomepageBits.vue?vue&type=script&lang=js&"
import style0 from "./HomepageBits.vue?vue&type=style&index=0&id=6b31e48c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b31e48c",
  null
  
)

export default component.exports